import { Link } from "react-router-dom";
import YoutubeEmbed from "./YoutubeEmbed";
import styles from "./About.module.css";

const About = () => {
  return (
    <div>
      <div className="section">
        <div className={styles.aboutContainer}>
          <div className={styles.aboutImg}>
            <YoutubeEmbed embedId="ZPs3URGs0KQ" />
          </div>
          <div className={styles.aboutText}>
            <h3>من نحن</h3>
            <h1> طريقة مبتكرة للتعلم</h1>
            <p>
              نحن نركز على إعداد مرشحينا لأن يكونوا جاهزين لسوق العمل. تعليم
              شامل يجمع بين المعرفة النظرية والمهارات العملية. يحصل المرشحون على
              أساس قوي في المبادئ الأكاديمية وتطبيقات العالم الحقيقي
            </p>
            <Link to="/courses" className={`primary-btn ${styles.aboutBtn}`}>
              اكتشف المزيد
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
export default About;
